<template>
  <div class="registerAudit">
    <div class="campus">注册管理</div>
    <div class="xiaoqu">
      <el-card :span="24">
        <div class="grid-content">
          <div class="header">注册审核</div>
          <div class="search mb-20">
            <span>状态：</span>
            <el-select v-model="status" placeholder="请选择" clearable @change="refreshData">
              <el-option label="未审核" :value="0" />
              <el-option label="已审核" :value="1" />
            </el-select>
            <span>用户名：</span>
            <el-input v-model="username" @keyup.13.native="getRegisterList" placeholder="请输入用户名" clearable></el-input>
            <el-button type="primary" class="buttons" @click="getRegisterList">查 询</el-button>
          </div>

          <div class="tableStyle">
            <el-table :data="tableData" style="width: 100%">
              <el-table-column prop="username" label="用户名" min-width="50" align="center">
              </el-table-column>
              <el-table-column prop="orgName" label="机构名" min-width="50">
              </el-table-column>
              <el-table-column prop="trueName" label="真实姓名" min-width="50">
              </el-table-column>
              <el-table-column prop="mobile" label="手机号" min-width="50">
              </el-table-column>
              <el-table-column prop="status" label="状态" min-width="50">
                <template slot-scope="scope">
                  <span>{{scope.row.status?'已审核':'未审核'}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="create_date" label="创建时间" min-width="50">
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button v-if="!scope.row.status" type="text" @click="editUser(scope.row)">审核</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="dz-flex dz-flex-justify-end mt-12">
            <el-pagination background @size-change="getRegisterList" @current-change="getRegisterList" :current-page.sync="page"
              :page-sizes="[5, 10, 30, 50, 100]" :page-size.sync="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
          </div>
        </div>
      </el-card>
    </div>
    <div class="dialogStyle">
      <el-dialog title="审核" :visible.sync="dialogEdit" width="550px" center>
        <div style="height：500px">
          <div class="item">
            <span>学生端小程序选择：</span>
            <el-select v-model="appId" placeholder="请选择">
              <el-option v-for="(item,index) in appList" :key="index" :label="item.name" :value="item.id" @click.native="appId = item.id">
              </el-option>
            </el-select>
          </div>
          <div class="item">
            <span>教师端小程序选择：</span>
            <el-select v-model="teacherId" placeholder="请选择">
              <el-option v-for="(item,index) in teacherAppList" :key="index" :label="item.name" :value="item.id"
                @click.native="teacherId = item.id">
              </el-option>
            </el-select>
          </div>
          <div class="item">
            <span>自动生成机构码：</span>
            <el-switch v-model="autocode" active-color="#13ce66" inactive-color="#ff4949" active-value="1" inactive-value="0">
            </el-switch>
          </div>
          <div class="item" v-if="!+autocode">
            <span>机构码：</span>
            <el-input v-model="orgcode"></el-input>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogEdit = false">取 消</el-button>
          <el-button type="primary" @click="submitEdit">通 过</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { $debounce } from '@/utils/index';
export default {
  name: 'registerAudit',
  data() {
    return {
      username: '',
      status: '',
      tableData: [],
      appList: [],
      teacherAppList: [],
      userId: '',
      appId: '',
      teacherId: '',
      autocode: '1',
      orgcode: '',
      // 检索表单数据对象
      page: 1,
      pageSize: 10,
      total: 0,
      dialogEdit: false,
    };
  },
  created() {
    this.$nextTick(() => {
      // 调用 查询出版社列表
      this.getRegisterList();
    });
  },
  methods: {
    refreshData() {
      this.page = 1;
      this.pageSize = 10;
      this.getRegisterList();
    },
    // 查询出版社列表
    getRegisterList() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/sys/user/org/info?page=' + this.page + '&pageSize=' + this.pageSize + '&status=' + this.status + '&username=' + this.username,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.tableData = result.data.data;
          this.total = result.data.size;
        })
        .catch((err) => {
          return this.$message.error('查询失败：' + err);
        });
    },
    // 审核出版社
    editUser(row) {
      this.userId = row.id;
      this.getAPPList();
      this.autocode = '1';
      this.orgcode = '';
      this.dialogEdit = true;
    },
    getAPPList() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgId = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/org/getMiniByOrgid?orgid=' + orgId,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.appList = result.data.data.miniList;
          this.teacherAppList = result.data.data.teacherMiniList;
        })
        .catch((err) => {
          return this.$message.error('查询失败：' + err);
        });
    },
    // 确认审核
    submitEdit: $debounce(function () {
      if (!this.appId) {
        return this.$message.error('请选择学生端小程序！');
      }
      if (!this.teacherId) {
        return this.$message.error('请选择教师端小程序！');
      }
      if (!+this.autocode && !this.orgcode) {
        return this.$message.error('请输入机构码！');
      }
      let data = {
        userid: this.userId,
        miniid: this.appId,
        teachminiid: this.teacherId,
        autocode: +this.autocode,
      };
      if (!+this.autocode) {
        data.orgcode = this.orgcode;
      }
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/sys/user/registeraudit',
        data,
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.$message.success(result.data.message);
          this.getRegisterList();
          this.dialogEdit = false;
        })
        .catch((err) => {
          return this.$message.error('审核失败' + err);
        });
    }, 500),
  },
};
</script>

<style lang="less" scoped>
.registerAudit {
  .jianyi {
    font-size: 12px !important;
    color: #cccccc;
    position: absolute;
    top: 0;
    left: 135px;
  }
  .el-button--text:active {
    color: #00a6e6;
  }
  .el-button--text {
    color: #00a6e6;
  }
  .avatar-uploader {
    img {
      width: 120px;
      height: 120px;
    }
  }
  /deep/.el-upload {
    text-align: left;
  }
  .tableImg {
    width: 80px;
    height: 80px;
  }
  /deep/.el-card__body {
    padding: 0 1.3vw;
  }
  .dialogStyle {
    .item {
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      span {
        width: 200px;
        display: inline-block;
        text-align: right;
      }
      /deep/.el-input__inner,
      .el-input {
        width: 240px;
      }
    }
  }
}
</style>
